import { IconButton, Spinner } from 'common/design-system/components-v2';
import React from 'react';
import { PendingFilterPanelStyled } from './PendingFilterPanel.styled';

export const PendingFilterPanel: React.FC = () =>
    <PendingFilterPanelStyled.SpinnerDiv>
        <IconButton iconProps={{ name: 'filter' }} size='small' />
        <Spinner size={14} />
    </PendingFilterPanelStyled.SpinnerDiv>;
